// extracted by mini-css-extract-plugin
export default {"dropdownLink":"IVqWoX","trigger":"V5u6Ga","active":"ByH4xY","root":"tWYGQs","dropdownRoot":"h3g52Z","dropdownList":"_5JPo6V","dropdownItem":"RbaSC5"};